import { getMenuFromPath } from '@/utils/Menu';

export const isLocalhost = () => {

    if(
        window.location.href.includes('localhost') ||
        window.location.href.includes('127.0.0.1')
    ){
        return true;
    }
    else{
        return false;
    }
}

export const isInternal = () => {

    if(window.location.href.includes('192.168.')){
        return true;
    }
    else{
        return false;
    }
}

export const isDemo = () => {

    if(window.location.href.includes('frontenddemo.') || window.location.href.includes('vigeprademo.')){
        return true;
    }
    else{
        return false;
    }
}

export const isProd = () => {

    if(window.location.href.includes('frontend.') || window.location.href.includes('vigepra.')){
        return true;
    }
    else{
        return false;
    }
}

export const getServerType = () => {

    var type = '';

    if(isLocalhost()){
        type = 'LOCAL';
    }
    else{
        if(isDemo()){
            type = 'DEMO';
        }
        else{
            if(isProd()){
                type = 'PROD';
            }
        }
    }

    return type;
}

export const backendApi = () => {

    var backend = null;
    var backendApi = null;

    if(isDemo()){
        backend = import.meta.env.VITE_BACKEND_DEMO;
    }
    else{
        if(isProd()){
            backend = import.meta.env.VITE_BACKEND_PROD;
        }
        else{
            if(isLocalhost()){
                backend = import.meta.env.VITE_BACKEND_LOCAL;
            }
            else{
                if(isInternal()){
                    backend = import.meta.env.VITE_BACKEND_INTERN;
                }
            }
        }
    }

    if(backend){
        backendApi = backend+import.meta.env.VITE_API_PATH;
    }

    return backendApi;
}

// clean the path
export const cleanPath = (path) => {

    var clean = path;
    
    // do not replace if root
    if(path !== '/'){
        clean = path.replace(/\/$/,'');
    }

    return clean;
}

// get url path to change the url when choosing a menu
export const getPathURL = (path) => {

    var urlPath = path;

    // if forgot password and already logged in, go to profile   
    switch(path){

        case '/forgot':
            urlPath = 'profile';
            break;
    }

    return urlPath;
}

// get parameter from url
export const getParameterURL = (router,name) => {
    const params = router.searchParams;
    return params.get(name);   
}

// get parameters from url
// array of names
export const getParametersURL = (router = null, names = []) => {

    let params;
    if(!router){
        params = new URLSearchParams(window.location.search);
    }
    else{        
        params = router.searchParams;
    }

    var result = {}

    // if array of names, get them. if not, get all
    if(names && names?.length > 0){
        names?.forEach((name) => {
            result[name] = params.get(name);
        });
    }
    else{
        result = Object.fromEntries(params.entries());
    }
    
    return result;
}

// remove parameter from url
export const removeParameterURL = (path,params,parameter) => {

    params.delete(parameter);

    const newQueryString = params.toString();

    if(newQueryString){
        return `${path}?${newQueryString}`;
    }

    // if no parameters, return path
    return path;
}

// add parameter to url
export const addParameterURL = (path,params,parameter,value,replace = true) => {

    // if empty value, remove
    if(value === null || typeof value === 'undefined' || value === ''){
        params.delete(parameter);
    }
    else{
        // if replace, replace same param if already there
        if(replace){
            params.set(parameter,value);
        }
        else{
            params.append(parameter,value);
        }
    }

    const newQueryString = params.toString();

    if(newQueryString){
        return `${path}?${newQueryString}`;
    }

    // if no parameters, return path
    return path;
}

// add parameters to url
// parameters = {cat:1,create:1}
export const addParametersURL = (path,params,parameters,replace = true) => {

    if(parameters){

        Object.keys(parameters)?.forEach((name) => {

            // if empty value, remove
            if(!parameters[name] || parameters[name].length === 0){
                params.delete(name);
            }
            else{

                // if replace, replace same param if already there
                if(replace){
                    params.set(name,parameters[name]);
                }
                else{
                    params.append(name,parameters[name]);
                }
            }
        });

        const newQueryString = params.toString();

        if(newQueryString){
            return `${path}?${newQueryString}`;
        }                    
    }

    // if no parameters, return path
    return path;
}

// add parameter to open a new ticket
export const goTicketURL = (t,url,user,router,menuConfig,sendMessage,clean = true) => {

    var path = url;

    // if clean is false, we preserve the previous params
    let params;
    if(clean){
        params = new URLSearchParams();
    }
    else{
        params = router.searchParams;
    }

    // get menu where we come from
    const menu = getMenuFromPath(user,menuConfig,router.pathname);

    // if already on tickets, do nothing
    if(menu === 'tickets'){
        sendMessage(t('tickets.already'));
        return null;
    }
    else{

        const split = menu?.split('/');

        var ticketCategory = null;
        var ticketSubcategory = null;
        switch(split[0]){            

            case 'planifications':

                ticketCategory = 'planifications';
                ticketSubcategory = 'planification_general';

                if(split?.length > 1){
                
                    switch(split[1]){
                    
                        case 'planification_reports':                            
                            ticketSubcategory = 'planification_reports';
                            break;

                        case 'config':
                            ticketSubcategory = 'planification_config';
                            break;

                        case 'info':
                            ticketSubcategory = 'planification_info';
                            break;
                    }
                }

                break;

            case 'resources':

                ticketCategory = 'resources';
                ticketSubcategory = 'resource_general';

                if(split?.length > 1){
                
                    switch(split[1]){
                    
                        case 'resource_groups':                            
                            ticketSubcategory = 'resource_groups';
                            break;

                        case 'resource_rentals':
                            ticketSubcategory = 'resource_rentals';
                            break;
                    }
                }

                break;

            default:
                ticketCategory = menu;
                break;
        }

        const variables = {
            'create': 1,
            'ticket_category_id': ticketCategory
        };
        
        if(ticketSubcategory){
            variables.ticket_subcategory_id = ticketSubcategory;
        }

        path = addParametersURL(path,params,variables);
        return router?.navigate(path);
    }
}

// generate url for the plan
export const getPlanUrl = (plan) => {

    var url = '';

    if(plan?.city && plan.city?.length > 0){
        url += plan?.city+',';
    }

    if(plan?.province && plan.province?.length > 0){
        url += plan?.province+',';
    }

    if(plan?.country?.name && plan.country.name.length > 0){
        url += plan.country.name;
    }

    if(url && url?.length > 0){
        const query = encodeURIComponent(url); 
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${query}&z=20`;
        url = googleMapsUrl;
    }

    return url;
}